import React, { useState, useEffect } from 'react';
import { Typography, Select, Paper, List, ListItem, ListItemText } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { FuseScrollbars } from '@fuse';

import moment from 'moment';

const useStyles = makeStyles(theme => ({
	root: {
		overflow: 'auto',
		maxHeight: 500
	},
	content: {
		overflow: 'hidden',
		opacity: 1,
		transition: theme.transitions.create(['opacity'], {
			easing: theme.transitions.easing.easeInOut,
			duration: theme.transitions.duration.short
		})
	}
}));

const Widget7 = props => {
	const classes = useStyles();

	const [currentRange, setCurrentRange] = useState(props.currentRange);
	const [data, setData] = useState([]);

	const handleChangeRange = ev => {
		setCurrentRange(ev.target.value);
	};

	useEffect(() => {
		if (props.data) {
			const sortedData = props.data.sort((a, b) => {
				// Convert to ISO string if it's a Date object to avoid moment.js warnings
				const timeA = a.time instanceof Date ? a.time.toISOString() : a.time;
				const timeB = b.time instanceof Date ? b.time.toISOString() : b.time;
				return moment(timeB) - moment(timeA);
			});
			setData(sortedData);
		}
	}, [props.data]);

	return (
		<Paper className="w-full rounded-8 border-1">
			<div className="flex flex-row items-center justify-between px-16 h-64 border-b-1">
				<Typography id={`widget-label-${props.id}`} className="text-16 font-bold">
					{props.title}
				</Typography>

				<Select
					id={`widget-select-${props.id}`}
					native
					value={currentRange}
					onChange={handleChangeRange}
					inputProps={{
						name: 'currentRange'
					}}
					disableUnderline={true}
				>
					{Object.entries(props.ranges).map(([key, n]) => (
						<option key={key} value={key} className="font-bold">
							{n}
						</option>
					))}
				</Select>
			</div>
			<FuseScrollbars className={classes.content}>
				<List id={`widget-list-${props.id}`} className={classes.root}>
					{data.map((item, i) => {
						if (currentRange === 'all' || currentRange === item.type) {
							return (
								<ListItem key={i}>
									<div className="flex flex-col">
										<Typography>{`${item.description}`}</Typography>
										{item.user !== 'root' && (
											<Typography>{`By: ${item.user.charAt(0).toUpperCase() + item.user.slice(1)}`}</Typography>
										)}
										<ListItemText secondary={moment(item.time instanceof Date ? item.time.toISOString() : item.time).format('LLL')} />
									</div>
								</ListItem>
							);
						} else return null;
					})}
				</List>
			</FuseScrollbars>
		</Paper>
	);
};

export default React.memo(Widget7);
